const Cnd = {
  symbol: 'cnd',
  color: '#000',
  plainIcon: c => {
    return `<path fill="${
      c ? c : this.color
    }" d="M16 32C7.163 32 0 24.837 0 16S7.163 0 16 0s16 7.163 16 16-7.163 16-16 16zm3.473-20.52l2.667-.612 1.033-1.7-1.02-1.674-1.306-.902L18.164 6l-1.655.933-2.648-.472-3.636 2.52-.283 2.941-1.543.644.178 2.729-1.077.858 1.076 3.072.162.322 1.138 3.163 2.34.828 1.733 1.764 1.994.698.902-.26 1.431-.165 2.098-.601 3.126-1.765-.818-3.232-1.574-.62-.784.897-2.205.542-3.207-.508-1.035-1.197.36-1.17-1.516-2.4 1.275-1.556.136-2.645 1.826-1.048 1.252-.5 1.7.307z" fill-rule="evenodd"/>`;
  },
  colorIcon() {
    return `<g fill="none" fill-rule="evenodd"><circle cx="16" cy="16" fill="#383939" r="16"/><path d="M19.473 11.479l2.667-.611 1.033-1.701-1.02-1.673-1.306-.902L18.164 6l-1.655.933-2.648-.472-3.636 2.519-.283 2.942-1.543.644.178 2.729-1.077.858 1.076 3.072.162.322 1.138 3.163 2.339.828 1.734 1.764 1.994.698.902-.26 1.431-.165 2.098-.601 3.126-1.765-.818-3.232-1.574-.62-.784.897-2.205.542-3.207-.508-1.035-1.197.36-1.171-1.516-2.399 1.275-1.556.136-2.645 1.826-1.048 1.252-.5 1.7.307z" fill="#fff"/></g>`;
  }
};
export default Cnd;
